import { BodyClass } from './core/body-class';
var cores = [new BodyClass(jQuery)];
jQuery.each(cores, function (_, core) { return core.run(); });
